import { useState } from 'react'

import BasicTable from 'Components/UI/Atoms/BasicTable'
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import ComplexDialog from 'Components/UI/Molecules/ComplexDialog'
import ComplexDialogActions from 'Components/UI/Molecules/ComplexDialog/Actions'
import Home from 'Components/UI/Organisms/Settings/Users/UsersDialog/Content/Home'
import Location from 'Components/UI/Organisms/Settings/Users/UsersDialog/Content/Location'
import Permissions from 'Components/UI/Organisms/Settings/Users/UsersDialog/Content/Permissions'
import { interfaces } from 'service/interfaces'

import useStyles from './styles'

const UsersDialog = (props) => {
  const { open, onClose, render, setRender, data: info, canEdit = false } = props

  const [data, setData] = useState(info)
  const classes = useStyles()

  const createDismissableSnackbar = useCustomSnackbar()

  const tabs = [
    {
      title: 'Inicio',
    },
    {
      title: 'Ubicación',
    },
    {
      title: 'Permisos',
    },
    {
      title: 'Historial',
      disabled: data.historial.length === 0,
    },
  ]

  const onSubmit = () => {
    interfaces.configUsersInterface
      .updateUser(data.data.id, data.data)
      .then((res) => {
        onClose()
        createDismissableSnackbar(res.data, {
          variant: 'success',
        })
        setRender(!render)
      })
      .catch((error) => {
        createDismissableSnackbar(error.response.data.data, {
          variant: 'error',
        })
      })
  }
  const renderForms = (index) => {
    switch (index) {
      case 0:
        return (
          <div className={classes.home}>
            <Home
              data={data}
              setData={setData}
              render={render}
              setRender={setRender}
              onClose={onClose}
            />
          </div>
        )
      case 1:
        return (
          <div className={classes.location}>
            <Location data={data} setData={setData} />
          </div>
        )
      case 2:
        return (
          <div className={classes.permissions}>
            <Permissions data={data} setData={setData} />
          </div>
        )
      case 3:
        return (
          <div className={classes.history}>
            <div style={{ width: '100%' }}>
              <BasicTable
                col={[
                  { title: 'Descripción', style: { width: '70%' } },
                  { title: 'Fecha', style: { width: '30%' } },
                ]}
                rows={data.historial.map((e) => {
                  return {
                    a: e.descripcion,
                    b: e.fecha,
                  }
                })}
              />
            </div>
          </div>
        )
      default:
        break
    }
  }

  return (
    <ComplexDialog
      open={open}
      onClose={onClose}
      tabs={tabs}
      title={`${data.data.nombre} ${data.data.apellido}`}
      subtitle={`${data.data.puesto} - ${data.data.area}`}
      children={renderForms}
      actions={
        <ComplexDialogActions
          onClose={onClose}
          handleSubmit={onSubmit}
          canEdit={canEdit}
          data={data.data}
          editMode={true}
        />
      }
    />
  )
}

export default UsersDialog
